export default __webpack_public_path__ + "static/media/system-volume-03.ae2868b1.svg";